import React from 'react';
import { Link } from 'react-router-dom';

import './type_nav.css';

export default class TypeNav extends React.Component {
    _renderItems(items) {
        return items.map(item => {

            let activeClass = "";

            if(item.status === true) activeClass = "active"; 

            return (
                <li className={`item ${activeClass}`} key={item.value}>
                    <Link to={item.path}>{item.value}</Link>
                </li>
            )
        })
    }
    
    render() {
        const { items } = this.props;

        return (
            <div className={'bnb_type_nav'}>
                <ul>
                    { this._renderItems(items) }
                </ul>
            </div>
        )
    }
}